/**
 * Catalog types are generated by the ingest pipeline and imported into
 * Firestore. The app treats them as read-only; it never parses source media,
 * chapter files, or dancer CSVs.
 */
export {};
